module.exports = "mutation updateCustomerProfile($updated:UserProfileInput!){updateCustomerProfile(updated:$updated){id firstName lastName email profileImage}}"